'use client'

import { storyblokEditable } from '@storyblok/react/rsc'
import { clsx } from 'clsx'
import { type FC, type PropsWithChildren, useEffect } from 'react'
import { useBoolean } from 'usehooks-ts'

import { Accordion, AccordionDetails, AccordionSummary } from 'base-ui'

import { useUrlHash } from '../../../generic-hooks'
import { type StoryblokComponentProps } from '../../model'
import { type StoryblokAccordionType } from '../../storyblok'

export const StoryblokAccordionContent: FC<
  PropsWithChildren<StoryblokComponentProps<StoryblokAccordionType>>
> = ({ blok, children }) => {
  const [hash] = useUrlHash()

  const {
    setTrue: expand,
    setValue: setExpanded,
    value: expanded,
  } = useBoolean(blok.open ?? false)

  useEffect(() => {
    const hasMatchingAnchor = blok.anchor && hash === `#${blok.anchor}`

    if (hasMatchingAnchor) {
      expand()
    }
  }, [blok.anchor, expand, hash])

  const id = blok.anchor === '' ? undefined : blok.anchor

  return (
    <Accordion
      {...storyblokEditable(blok)}
      className={clsx(blok.anchor && 'scroll-mt-4')}
      expanded={expanded}
      id={id}
      onChange={(_event, value) => {
        setExpanded(value)
      }}
    >
      <AccordionSummary>{blok.title}</AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  )
}
